var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import logger from "@rentiohq/shared-frontend/dist/logger";
import * as authSelectors from "@rentiohq/shared-frontend/dist/reduxV2/auth/auth.selectors";
import * as preferenceApi from "@rentiohq/shared-frontend/dist/reduxV2/preferences/preference.api";
import { call, put, select, takeEvery, takeLatest } from "redux-saga/effects";
import { ONLINE, TAB_FOREGROUND } from "../applyWindowStateListener";
import * as systemActions from "./system.actions";
import * as systemApi from "./system.api";
import { EPreferencePersistScope } from "./system.types";
function getRemotePreferencesStartFlow() {
    var hasAccessToken, _a, _b, preferences, unknownError_1, error;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 4, , 6]);
                _b = (_a = authSelectors).hasAccessToken;
                return [4 /*yield*/, select()];
            case 1:
                hasAccessToken = _b.apply(_a, [_c.sent()]);
                if (!hasAccessToken) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, call(preferenceApi.getUserPreferences)];
            case 2:
                preferences = _c.sent();
                // Falls back to an empty store to match v1, whose getSettings always resolved to
                // an object; the reducer merges the result into existing preferences.
                return [4 /*yield*/, put(systemActions.getRemotePreferences.actions.success({
                        preferences: preferences !== null && preferences !== void 0 ? preferences : {},
                    }))];
            case 3:
                // Falls back to an empty store to match v1, whose getSettings always resolved to
                // an object; the reducer merges the result into existing preferences.
                _c.sent();
                return [3 /*break*/, 6];
            case 4:
                unknownError_1 = _c.sent();
                error = unknownError_1;
                logger.logError({ error: error });
                return [4 /*yield*/, put(systemActions.getRemotePreferences.actions.failure(error))];
            case 5:
                _c.sent();
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function setPreferencesFlow(action) {
    var payload, persistScope, preferences, _a, unknownError_2, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                payload = action.payload;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 8, , 9]);
                persistScope = payload.persistScope, preferences = payload.preferences;
                _a = persistScope;
                switch (_a) {
                    case EPreferencePersistScope.RemoteUser: return [3 /*break*/, 2];
                    case EPreferencePersistScope.RemoteBroker: return [3 /*break*/, 4];
                }
                return [3 /*break*/, 6];
            case 2: return [4 /*yield*/, call(preferenceApi.updateUserPreferences, preferences)];
            case 3:
                _b.sent();
                return [3 /*break*/, 7];
            case 4: return [4 /*yield*/, call(systemApi.setPreferencesForBroker, preferences)];
            case 5:
                _b.sent();
                return [3 /*break*/, 7];
            case 6: return [3 /*break*/, 7];
            case 7: return [3 /*break*/, 9];
            case 8:
                unknownError_2 = _b.sent();
                error = unknownError_2;
                logger.logError({ error: error });
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function getIndexLastModifiedStartFlow() {
    var headers, unknownError_3, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4 /*yield*/, call(systemApi.getIndexLastModified, "".concat(window.location.origin, "/index.html"))];
            case 1:
                headers = (_a.sent()).headers;
                return [4 /*yield*/, put(systemActions.getIndexLastModified.actions.success({ headers: headers }))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3:
                unknownError_3 = _a.sent();
                error = unknownError_3;
                logger.logError({ error: error });
                // Failed?
                return [4 /*yield*/, put(systemActions.getIndexLastModified.actions.failure({ error: error }))];
            case 4:
                // Failed?
                _a.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeEvery([TAB_FOREGROUND, ONLINE, systemActions.getRemotePreferences.types.START], getRemotePreferencesStartFlow)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeEvery(systemActions.setPreferences.getType(), setPreferencesFlow)];
            case 2:
                _a.sent();
                return [4 /*yield*/, takeLatest([TAB_FOREGROUND, ONLINE, systemActions.getIndexLastModified.types.START], getIndexLastModifiedStartFlow)];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
// eslint-disable-next-line import/no-default-export
export default saga;
